import type { SVGProps } from "react"
import React from "react"

export const ShareIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  fill = "#000",
  width = 20,
  height = 20,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <title>Sharing Icon</title>
    <path
      fill={fill}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.6599 5.51997C19.6599 6.82337 18.6033 7.87997 17.2999 7.87997C16.6286 7.87997 16.0227 7.59962 15.5929 7.1496L8.92917 11.2233C9.01391 11.4665 9.05997 11.7279 9.05997 12C9.05997 12.2721 9.01391 12.5335 8.92916 12.7768L15.5929 16.8504C16.0226 16.4004 16.6285 16.12 17.2999 16.12C18.6033 16.12 19.6599 17.1766 19.6599 18.48C19.6599 19.7834 18.6033 20.84 17.2999 20.84C15.9965 20.84 14.9399 19.7834 14.9399 18.48C14.9399 18.2079 14.986 17.9465 15.0707 17.7033L8.40701 13.6296C7.97727 14.0797 7.37136 14.36 6.69997 14.36C5.39657 14.36 4.33997 13.3034 4.33997 12C4.33997 10.6966 5.39657 9.64001 6.69997 9.64001C7.37137 9.64001 7.97729 9.92038 8.40703 10.3704L15.0708 6.29675C14.986 6.0535 14.9399 5.79212 14.9399 5.51997C14.9399 4.21658 15.9965 3.15997 17.2999 3.15997C18.6033 3.15997 19.6599 4.21658 19.6599 5.51997Z"
    />
  </svg>
)
